import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Bear(props: PresetArtProps) {
  return (
    <PresetFrame background="#92400e" {...props}>
      <circle cx="20" cy="21" r="7" fill="#ffffff" />
      <circle cx="44" cy="21" r="7" fill="#ffffff" />
      <circle cx="32" cy="36" r="16" fill="#ffffff" />
      <circle cx="26" cy="32" r="2.5" fill="#1f2937" />
      <circle cx="38" cy="32" r="2.5" fill="#1f2937" />
      <ellipse cx="32" cy="41" rx="4" ry="3" fill="#1f2937" />
    </PresetFrame>
  );
}
